import logo from "../../../../theme/img/logo/logo2020-500.png";
import React from "react";
import {useTranslation} from "react-i18next";
import {generate} from "../../../../routing/routes";
import {BackButton, ButtonArea, NextButton} from "../../../shared/components/Buttons";
import {ErrorPage} from "./ErrorPage";

export const NotFound = () => {
    const { t } = useTranslation();
    return <ErrorPage><div className="bg-white py-24 px-6 sm:py-32 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
            <img src={logo} alt="logo" className={"w-40 mx-auto"} />

            <p className="mt-10 text-lg leading-8 text-gray-600">
                {t('followup.draft_not_found')}
            </p>
            <div className="mt-6 text-lg leading-8 text-gray-600">
                <ButtonArea>
                    <BackButton href={generate('account_dashboard')}>{t('account_button.dashboard')}</BackButton>
                    <NextButton classname="ml-auto" href={generate('book')}>{t('followup.new_project')}</NextButton>
                </ButtonArea>
            </div>

        </div>
    </div>
    </ErrorPage>
}